import React from "react";
import type { ScrollPosStore } from "./scrollPosStore";

const ScrollPosContext = React.createContext<ScrollPosStore | null>(null);

const ScrollPosProvider = ScrollPosContext.Provider;

function useScrollPosStore() {
  const store = React.useContext(ScrollPosContext);
  if (!store) throw new Error("ScrollPosProvider is missing");
  return store;
}

function useScrollPos() {
  const store = useScrollPosStore();
  return React.useSyncExternalStore(store.subscribe, store.get, store.get);
}

export { ScrollPosProvider, useScrollPos };
